import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-alert-location',
  templateUrl: './alert-location.component.html',
  styleUrls: ['./alert-location.component.scss']
})
export class AlertLocationComponent   {

  constructor(public dialogRef: MatDialogRef<AlertLocationComponent>,) { }


  save(confirm){
    this.dialogRef.close(confirm);
  }
}
